// Note: Everything in a frontend is public anyway, but you might wanna consider moving this elsewhere nonetheless, ideally serving through your backend
export const API_KEY = "pk_dOYo0TxfW3lsiQu3l3HgzWl6";
export const CLIENT_ID =
  "BK4PX0MHV5JH2hEjaO_1_paDVWf_mA8mOyiXn7H2t8Czacv5Uffi3scmdNECInpezcCYdGI1oPBitLbeMYaDXi4";
